var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.9984,2.9998 C11.7954,2.9998 14.9074,6.1958 15.7694,7.1758 C16.0724,7.5228 16.0724,8.0428 15.7724,8.3878 C14.9074,9.3698 11.7954,12.5658 7.9984,12.5658 C4.2014,12.5658 1.0904,9.3698 0.2274,8.3898 C-0.0756,8.0428 -0.0756,7.5228 0.2254,7.1778 C1.0904,6.1958 4.2014,2.9998 7.9984,2.9998 Z M7.9984,4.1998 C4.9074,4.1998 2.2544,6.7388 1.2944,7.7828 C2.2504,8.8238 4.9054,11.3658 7.9984,11.3658 C11.0894,11.3658 13.7424,8.8268 14.7024,7.7828 C13.7424,6.7388 11.0894,4.1998 7.9984,4.1998 Z M7.9984,4.9301 C9.5714,4.9301 10.8514,6.2101 10.8514,7.7831 C10.8514,9.3551 9.5714,10.6351 7.9984,10.6351 C6.4254,10.6351 5.1454,9.3551 5.1454,7.7831 C5.1454,6.2101 6.4254,4.9301 7.9984,4.9301 Z M7.9984,6.1301 C7.0874,6.1301 6.3464,6.8721 6.3464,7.7831 C6.3464,8.6941 7.0874,9.4351 7.9984,9.4351 C8.9094,9.4351 9.6504,8.6941 9.6504,7.7831 C9.6504,6.8721 8.9094,6.1301 7.9984,6.1301 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-eye"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#868B92",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.debf82c54e7dc376bac59eeba3d6dff7.svg";
export { ForwardRef as ReactComponent };